
import React, { useState, useEffect } from 'react';
import ErrorIcon from "../../assets/error.inline.svg";
import { apiClient } from "../../utils/apiClient"

const BDMFinder = () => {
  const [data, setData] = useState(null);
  const [hasResult, setHasResult] = useState(null);
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);
  const RECAPTCHA_SITE_KEY = '6LeRCeArAAAAAIkpJqITc_c8fLJdkwD530DDtHGl';
  const RECAPTCHA_ACTION = 'bdm_search';
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    FCAReference: '',
    email: ''
  });
  const [errors, setErrors] = useState({
    FCAReference: '',
    email: ''
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }

  const numericRegex = /^\d*$/;
  const onReferenceChange = (e) => {
    const newValue = e.target.value;

    if (numericRegex.test(newValue)) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        FCAReference: newValue,
      }));
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrors({ FCAReference: '', email: '' });
    setHasResult(null);
    setData(null);

    let valid = true;
    let newErrors = { FCAReference: '', email: '' };

    if (!formData.email || formData.email.trim() === '' || formData.email.includes('@') === false) {
      valid = false;
      newErrors.email = 'Please enter a valid email address';
    }

    if (!valid) {
      setErrors(newErrors);
      setIsSubmitting(false);
      return false;
    }
    
    // eslint-disable-next-line no-undef
    if (!recaptchaLoaded || typeof grecaptcha === 'undefined' || !grecaptcha.enterprise) {
      setIsSubmitting(false);
      return false;
    }

    try {
      const token = await new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        grecaptcha.enterprise.ready(async () => {
          try {
            // eslint-disable-next-line no-undef
            const t = await grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action: RECAPTCHA_ACTION });
            resolve(t);
          } catch (err) {
            reject(err);
          }
        });
      });
      apiClient.get(`/bdm?fcaReference=${formData.FCAReference}&email=${formData.email}`, { headers: { 'Recaptcha-Token': token } }).then((response) => {
        const { success, name, email, phone, message} = response;
        if(response && success && name && email && phone) {
          setData({
            name,
            email,
            phone
          });
          setHasResult(true);
          setFormData({ FCAReference: '', email: '' });
        } else {
          if (response && !success && message) {
            setFormData({ FCAReference: '', email: message });
            setHasResult(null);
          } else {
            setHasResult(false);
          }
        }
        // Handle successful response
      }).catch((error) => {
        console.error('API error:', error);
        // Handle error response
      }).finally(() => {
        setIsSubmitting(false);
      });
    } catch (error) {
      console.log('Unexpected error:', error);
    }
  };

  useEffect(() => {
    const scriptId = 'recaptcha-enterprise-script';
    if (document.getElementById(scriptId)) {
      
      // eslint-disable-next-line no-undef
      if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
        // eslint-disable-next-line no-undef
        grecaptcha.enterprise.ready(() => {
          setRecaptchaLoaded(true);
        });
      }
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      // eslint-disable-next-line no-undef
      if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
        // eslint-disable-next-line no-undef
        grecaptcha.enterprise.ready(() => {
          setRecaptchaLoaded(true);
        });
      } else {
        console.error('grecaptcha.enterprise objektum nem található a script betöltése után.');
      }
    };

    script.onerror = () => {
    };

    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById(scriptId);
      if (scriptToRemove) {
        document.head.removeChild(scriptToRemove);
      }
    };
  }, []);

  return (
    <section className="bdm-finder">
      <div>
        <h3 className="bdm-finder__title">Find your BDM</h3>
        <p className="bdm-finder__desc">
          Our experienced field and telephone based Business Development Managers are on hand to provide you with dedicated support.
        </p>
        <p className="bdm-finder__desc bdm-finder__desc--bold">
          To find your BDM, please complete below fields and click ‘Click to find your BDM’.
        </p>
      </div>
      <form className="bdm-finder__form" onSubmit={onSubmit}>
        <div className={`bdm-finder__form-group ${errors.FCAReference !== '' ? 'bdm-finder__form-group--error' : ''}`}>
          <label htmlFor="FCA-reference" className="bdm-finder__label">FCA reference*</label>
          <input onChange={onReferenceChange} value={formData.FCAReference} className="bdm-finder__input" type="text" id="FCA-reference" name="FCAReference" placeholder="Enter FCA reference" />
          {errors.FCAReference !== '' && <p className="bdm-finder__error"><ErrorIcon /> {errors.FCAReference}</p>}
        </div>
        <div className={`bdm-finder__form-group ${errors.email !== '' ? 'bdm-finder__form-group--error' : ''}`}>
          <label htmlFor="email" className="bdm-finder__label">Email address*</label>
          <input onChange={onChange} value={formData.email} className="bdm-finder__input" type="text" id="email" name="email" placeholder="Enter email address" />
          {errors.email !== '' && <p className="bdm-finder__error"><ErrorIcon /> {errors.email}</p>}
        </div>
        <button disabled={formData.FCAReference.length === 0 || formData.email.length === 0 || !recaptchaLoaded || isSubmitting} type="submit" className="bdm-finder__button">Click to find your BDM</button>
      </form>
      {hasResult === false && data === null && (
        <>
          <div className="bdm-finder__result-no-result">
            <h3 className="bdm-finder__result-no-result-title">
              No result found
            </h3>
            <p className="bdm-finder__result-no-result-desc">
              We are unable to find a match for the information you have entered. Please check there are no additional spaces after the FCA reference / email address and try again, or contact our Broker Support helpdesk for further assistance.
            </p>
          </div>
        </>
      )}
      {hasResult === true && !!data && (
        <>
          <div className="bdm-finder__result">
            <h3 className="bdm-finder__result-title">
              Your BDM is:
            </h3>
            <div className="bdm-finder__result-item">
              <label className="bdm-finder__result-label">Name:</label>
              <p className="bdm-finder__result-value">{data.name}</p>
            </div>
            <div className="bdm-finder__result-item">
              <label className="bdm-finder__result-label">Phone:</label>
              <p className="bdm-finder__result-value">{data.phone}</p>
            </div>
            <div>
              <label className="bdm-finder__result-label">Email:</label>
              <p className="bdm-finder__result-value">{data.email}</p>
            </div>
          </div>
        </>
      )}
    </section>
  )
}

export default BDMFinder;